/** Ephemeral Owlbear nudge. D1 remains the source of truth. */
export const SHEET_SYNC_CHANNEL = 'com.lordofdisndat.dcc.sheet/sync/v1';

export interface SheetSyncSignal {
  type: 'sheet-sync';
  reason?: string;
}

export function isSheetSyncSignal(value: unknown): value is SheetSyncSignal {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const signal = value as Record<string, unknown>;
  return signal.type === 'sheet-sync' && (signal.reason === undefined || typeof signal.reason === 'string');
}
